import useDriftClient from 'src/hooks/useDriftClient';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { fetchUserStatsAccount } from '@velocity-exchange/sdk';
import { QueryDisabledError } from 'src/utils/error/QueryDisabledError';
import { useQuery } from '@tanstack/react-query';
import { createQueryKey } from 'src/utils/query/createQueryKey';

function rootAuthorityUserStatsAccountQueryKey(authority?: string) {
	return createQueryKey('rootAuthorityUserStatsAccount', authority);
}

/**
 * Fetches the stats account for the "root" authority of the current account,
 * which may either be the connected wallet or the main wallet if the current
 * account is a delegate.
 */
export default function useRootAuthorityUserStatsAccount() {
	const connection = useDriftStore((s) => s.connection.current);
	const driftClient = useDriftClient();
	const rootAuthority = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.authority
	);

	const disabled = !connection || !driftClient?.program || !rootAuthority;

	const queryFn = () => {
		if (disabled) {
			throw new QueryDisabledError();
		}

		return fetchUserStatsAccount(
			connection,
			driftClient?.program,
			rootAuthority
		);
	};

	return useQuery({
		queryKey: rootAuthorityUserStatsAccountQueryKey(
			rootAuthority?.toString() ?? ''
		),
		queryFn,
		enabled: !disabled,
	});
}
